export default {"src":"/_next/static/media/checkmark_light.01595d08.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};